import { render, staticRenderFns } from "./indexCustomer.vue?vue&type=template&id=0cb7a0aa"
import script from "./indexCustomer.vue?vue&type=script&lang=js"
export * from "./indexCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports